import Vue from 'vue';
import { Button, Icon, Toast, Loading, Image, Cell, Empty } from 'vant';

Vue.use(Button)
  .use(Icon)
  .use(Toast)
  .use(Loading)
  .use(Image)
  .use(Cell)
  .use(Empty);
